import { filterObject, parseSearchParams } from '@/helpers/core';

import { FRAME_SEARCH_PARAMS } from '@/config/frame-query-params';
import MainStorage from '@/storage/main';

function saveFrameQueryParams(): void {
  const params = parseSearchParams(window.location.search);
  const filteredParams = filterObject(params, FRAME_SEARCH_PARAMS);

  if (Object.keys(filteredParams).length > 0) {
    MainStorage.saveFrameSearchParams(filteredParams);
  }
}

export { saveFrameQueryParams };
